var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 14.37h-23a8.5 8.5 0 0 0 0 17h23a8.5 8.5 0 0 0 0-17z",
    fill: "#A5C6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.33 25.11c-1.57 0-2.41-.81-3.03-1.4-.53-.51-.88-.84-1.64-.84-.76 0-1.11.33-1.64.84-.61.59-1.46 1.4-3.03 1.4-1.57 0-2.41-.81-3.02-1.4-.53-.51-.88-.84-1.64-.84-.76 0-1.11.33-1.64.84-.62.59-1.46 1.4-3.03 1.4-.55 0-1-.45-1-1s.45-1 1-1c.76 0 1.11-.33 1.64-.84.61-.59 1.46-1.4 3.02-1.4s2.41.81 3.02 1.4c.53.51.88.84 1.64.84.76 0 1.11-.33 1.64-.84.61-.59 1.46-1.4 3.03-1.4 1.57 0 2.41.81 3.03 1.4.53.51.88.84 1.64.84.55 0 1 .45 1 1s-.45 1-1 1h.01z",
    fill: "#5593E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41.31H12c-4.96 0-9-4.04-9-9v-8.62c0-.55.45-1 1-1s1 .45 1 1v8.62c0 3.86 3.14 7 7 7h24c3.86 0 7-3.14 7-7v-9.43c0-4.14-3.36-7.5-7.5-7.5h-3.4c-.55 0-1-.45-1-1s.45-1 1-1h3.4c5.24 0 9.5 4.26 9.5 9.5v9.43c0 4.96-4.04 9-9 9z",
    fill: "#424A56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.15 21.99c-.55 0-1-.45-1-1v-8.93c0-1.93 1.57-3.5 3.5-3.5.55 0 1 .45 1 1s-.45 1-1 1c-.83 0-1.5.67-1.5 1.5v8.93c0 .55-.45 1-1 1zM27.84 21.99c-.55 0-1-.45-1-1v-8.93c0-.93.36-1.81 1.03-2.47 1.32-1.32 3.63-1.32 4.95 0A.996.996 0 1 1 31.41 11c-.57-.57-1.55-.57-2.12 0-.28.28-.44.66-.44 1.06v8.93c0 .55-.45 1-1 1h-.01z",
    fill: "#424A56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.42 11.29c-.26 0-.51-.1-.71-.29-.28-.28-.66-.44-1.06-.44-.55 0-1-.45-1-1s.45-1 1-1c.94 0 1.81.36 2.47 1.03.39.39.39 1.02 0 1.41-.2.19-.45.29-.71.29h.01zM27.84 15.38h-5.69c-.55 0-1-.45-1-1s.45-1 1-1h5.69c.55 0 1 .45 1 1s-.45 1-1 1zM27.84 19.28h-5.69c-.55 0-1-.45-1-1s.45-1 1-1h5.69c.55 0 1 .45 1 1s-.45 1-1 1z",
    fill: "#424A56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtPool);
export default __webpack_public_path__ + "static/media/art-pool.46deb83588be0a10ef903b169f6d852b.svg";
export { ForwardRef as ReactComponent };